import { HTTPInstanceWithPrefix } from '@/http/http-instance-with-prefix'
import {
  DishModel,
  DishSizesModel,
  ToppingsModel
} from './DishConfigurationAPI.model'

class DishConfigurationAPI {
  static getDish = (dishId: string): Promise<DishModel> =>
    HTTPInstanceWithPrefix.get(`/dishes/${dishId}`).then(
      response => response.data
    )

  static getDishSizes = (): Promise<DishSizesModel> =>
    HTTPInstanceWithPrefix.get('/dish-sizes').then(response => response.data)

  static getToppings = (): Promise<ToppingsModel> =>
    HTTPInstanceWithPrefix.get('/toppings').then(response => response.data)
}

export default DishConfigurationAPI
